/* Optional editorial interactions. Existing cart/fireworks handlers retain ownership. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function selectCategory(host, id, focus = false) {
    host.querySelectorAll('[data-difference-tab]').forEach(button => {
      const active = button.dataset.differenceTab === id;
      button.setAttribute('aria-expanded', String(active));
      if (active && focus) button.focus();
    });
    host.querySelectorAll('[data-difference-panel]').forEach(panel => panel.hidden = panel.dataset.differencePanel !== id);
  }
  function init(root = document) {
    root.querySelectorAll('[data-difference]').forEach(host => {
      if (host.dataset.ready) return;
      host.dataset.ready = 'true';
      const first = host.querySelector('[data-difference-tab]');
      if (first) selectCategory(host, first.dataset.differenceTab);
      host.querySelectorAll('[data-difference-list-toggle]').forEach(button => {
        const list = document.getElementById(button.getAttribute('aria-controls'));
        if (!list || !host.contains(list)) return;
        list.querySelectorAll('[data-difference-list-extra]').forEach(item => item.hidden = true);
        button.hidden = false;
      });
      host.addEventListener('click', event => {
        const button = event.target.closest('[data-difference-tab]');
        if (button) selectCategory(host, button.dataset.differenceTab);
        const toggle = event.target.closest('[data-difference-list-toggle]');
        if (!toggle || !host.contains(toggle)) return;
        const list = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!list || !host.contains(list)) return;
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        list.querySelectorAll('[data-difference-list-extra]').forEach(item => item.hidden = !expanded);
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded ? toggle.dataset.showLess : toggle.dataset.showMore;
        if (!expanded && document.activeElement === toggle) toggle.scrollIntoView({ block: 'nearest' });
      });
      host.addEventListener('keydown', event => {
        if (!event.target.matches('[data-difference-tab]')) return;
        const buttons = [...host.querySelectorAll('[data-difference-tab]')];
        let i = buttons.indexOf(event.target);
        if (['ArrowRight','ArrowDown'].includes(event.key)) i = (i + 1) % buttons.length;
        else if (['ArrowLeft','ArrowUp'].includes(event.key)) i = (i - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') i = 0;
        else if (event.key === 'End') i = buttons.length - 1;
        else return;
        event.preventDefault(); selectCategory(host, buttons[i].dataset.differenceTab, true);
      });
    });
    root.querySelectorAll('[data-forecast]').forEach(host => {
      if (host.dataset.ready) return;
      host.dataset.ready = 'true';
      const deck = host.querySelector('.bf-forecast__deck');
      const cards = [...deck.children];
      let active = 0;
      const update = () => {
        const left = deck.getBoundingClientRect().left;
        active = cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? i : best, 0);
        host.querySelector('[data-forecast-status]').textContent = `${active + 1} / ${cards.length}`;
        host.querySelector('[data-forecast-step="-1"]').disabled = active === 0;
        host.querySelector('[data-forecast-step="1"]').disabled = active === cards.length - 1;
      };
      host.addEventListener('click', event => {
        const button = event.target.closest('[data-forecast-step]'); if (!button) return;
        const card = cards[Math.max(0, Math.min(cards.length - 1, active + Number(button.dataset.forecastStep)))];
        if (card) deck.scrollTo({ left: deck.scrollLeft + card.getBoundingClientRect().left - deck.getBoundingClientRect().left - 4, behavior: reduced.matches ? 'instant' : 'smooth' });
      });
      deck.addEventListener('scroll', update, {passive:true}); update();
    });
  }
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-recipe-open],[data-recipe-close]'); if (!control) return;
    const tile = control.closest('.bf-os-mosaic__tile');
    const front = tile.querySelector('[data-recipe-front]'), back = tile.querySelector('[data-recipe-back]');
    const show = control.hasAttribute('data-recipe-open');
    front.hidden = show; back.hidden = !show;
    tile.querySelector('[data-recipe-open]').setAttribute('aria-expanded', String(show));
    if (show) front.querySelectorAll('video').forEach(video => video.pause());
    (show ? back.querySelector('button') : front.querySelector('[data-recipe-open]')).focus();
  });
  document.addEventListener('shopify:block:select', event => {
    const panel = event.target.closest('[data-difference-panel]');
    if (panel) selectCategory(panel.closest('[data-difference]'), panel.dataset.differencePanel);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
